import type { HTMLAttributes, ReactElement, ReactNode } from "react";

export type LdsBadgeTone =
  | "neutral"
  | "info"
  | "success"
  | "warning"
  | "danger";

export type LdsBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: LdsBadgeTone;
  children: ReactNode;
};

const toneClasses: Record<LdsBadgeTone, string> = {
  neutral: "border-slate-200 bg-slate-50 text-slate-600 dark:border-white/10 dark:bg-white/5 dark:text-slate-300",
  info: "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-400/30 dark:bg-sky-400/10 dark:text-sky-200",
  success: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-400/30 dark:bg-emerald-400/10 dark:text-emerald-200",
  warning: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-400/30 dark:bg-amber-400/10 dark:text-amber-200",
  danger: "border-red-200 bg-red-50 text-red-700 dark:border-red-400/30 dark:bg-red-400/10 dark:text-red-200",
};

export function LdsBadge({
  tone = "neutral",
  className,
  children,
  ...props
}: LdsBadgeProps): ReactElement {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold ${toneClasses[tone]}${className ? ` ${className}` : ""}`}
      {...props}
    >
      {children}
    </span>
  );
}
